import { configureStore } from '@reduxjs/toolkit';
import {thunk} from 'redux-thunk'; // Correct import (named export)
import favouritesReducer from '../Providers/favouritesProvider';
import itemsReducer from './itemsSlice';
import addressReducer from '../Providers/addressProvider';
import cartItemsReducer from '../Providers/cartProvider';
import ordersReducer from './orderSlice';
import authReducer from './authSlice';
import customSizeReducer from '../Providers/customSizeProvider';
import subscribeReducer from '../Providers/subscribeProvider';


 const store = configureStore({
  reducer: {
    favourites: favouritesReducer,
    items: itemsReducer, 
    address: addressReducer,
    cartItems: cartItemsReducer,
    orders: ordersReducer,
    auth: authReducer,
    customSize:customSizeReducer,
    subscribe: subscribeReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
});
 
export default store;